import { list } from "@mc/mc-legacy";
import QSignDataApi from "../api/gen/qsign/QSignDataApi";
export const KE_SCHVALENI_LIST = "keSchvaleniList";

const getRequestsByIds = (ids) => {
  return QSignDataApi.findRequestsByIds(ids);
};

const getMsNevyrizeneAllIds = (parent, filter) => {
  return QSignDataApi.findNevyrizenePozadavkySchvalujici();
};

export function fetchIfNeeded(forceFetch) {
  return (dispatch) => {
    dispatch(
      list.InfiniteListActions.fetchIfNeeded(
        KE_SCHVALENI_LIST,
        null,
        getMsNevyrizeneAllIds,
        getRequestsByIds,
        forceFetch
      )
    );
  };
}
export function loadMore() {
  return (dispatch, getState) => {
    dispatch(list.InfiniteListActions.loadMore(KE_SCHVALENI_LIST, getRequestsByIds));
  };
}
export function invalidateKeSchvaleniNevyrizene() {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.invalidate(KE_SCHVALENI_LIST));
  };
}
export function filterUkoly(filter) {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.filter(KE_SCHVALENI_LIST, filter));
  };
}
